import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { SiteFooter } from '../components/ui/SiteFooter';
import { SiteHeader } from '../components/ui/SiteHeader';
import { FoundingOffer } from '../components/practitioners/FoundingOffer';
import { CoffeeChatInvite } from '../components/practitioners/CoffeeChatInvite';
import { foundingOffer } from '../data/foundingOffer';
export function PractitionersPage() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-971" data-mp="3w1zh7i7pk7vd">
      {/* Navigation */}
      <SiteHeader currentPath="/practitioners" data-id="element-972" data-mp="3n1uirxkhsjtc" />

      <main className="pt-16 md:pt-24 pb-24" data-id="element-973" data-mp="3n0jezxr1rc28">
        {/* Intro */}
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-974" data-mp="3i39k42kw2870">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-5" data-id="element-975" data-mp="3i4uhs12i2793">
            For Practitioners
          </p>

          <h1 className="font-serif text-4xl md:text-6xl text-charcoal leading-[1.05] mb-6 tracking-tight" data-id="element-976" data-mp="26nbek8ox64aj">
            Join the Network
          </h1>

          <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-977" data-mp="zjjbg07u2xvf">
            Become part of a curated community of trusted practitioners shaping
            the future of women's wellness.
          </p>
        </div>

        {/* Founding member offer */}
        <div className="max-w-3xl mx-auto px-6 mt-10" data-id="element-978" data-mp="ukg4ubc7gjlc">
          <div className="rounded-3xl bg-purple-800 px-7 py-8 md:px-10 md:py-9 text-center" data-id="element-979" data-mp="fwv2ijn5moeh">
            <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-200" data-id="element-980" data-mp="komwl45irc9d">
              <SparklesIcon aria-hidden="true" className="w-4 h-4" data-id="element-981" data-mp="6xzvj5cadaa4" />
              Founding member offer
            </p>

            <p className="mt-4 font-serif text-2xl md:text-3xl text-white leading-snug" data-id="element-982" data-mp="3t3eoscttq4qr">
              {foundingOffer.headline}
            </p>

            <p className="mt-4 text-base text-purple-100/90 leading-relaxed max-w-xl mx-auto" data-id="element-983" data-mp="1x3vx3yywaai">
              {foundingOffer.subline}
            </p>

            <p className="mt-5 text-sm text-purple-200/80" data-id="element-984" data-mp="3a7xx6sg7rscv">
              Offer closes {foundingOffer.deadline}.
            </p>

            <a href="/practitioners/join" className="mt-7 inline-flex items-center justify-center rounded-full bg-white px-8 py-3.5 text-base font-semibold text-purple-900 transition-colors duration-200 ease-out hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-200 focus-visible:ring-offset-2 focus-visible:ring-offset-purple-800" data-id="element-985" data-mp="359mmygm0bfu4">
              Join Fem Entity
            </a>

            <p className="mt-5 text-sm text-purple-100/90" data-id="element-986" data-mp="3j089qgel09xa">
              Already a member?{' '}
              <a href="/practitioners/account/membership" className="font-semibold text-white underline underline-offset-4 decoration-purple-300 hover:text-purple-100 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-200" data-id="element-987" data-mp="2cjnxwl7tbipg">
                Manage your membership
              </a>
            </p>
          </div>
        </div>

        {/* Offer detail */}
        <div className="max-w-3xl mx-auto px-6 mt-20 md:mt-24" data-id="element-988" data-mp="wzwzipp6cyej">
          <FoundingOffer data-id="element-989" data-mp="11rerio97zond" />
        </div>

        {/* Application form */}
        <section id="apply" aria-labelledby="apply-heading" className="max-w-3xl mx-auto px-6 mt-20 md:mt-24 scroll-mt-28" data-id="element-990" data-mp="11trexgxqyr7t">
          <div className="rounded-3xl border border-purple-200 bg-white px-7 py-10 md:px-12 md:py-12 text-center shadow-[0_18px_50px_-30px_rgba(44,44,44,0.5)]" data-id="element-991" data-mp="1ar1sxa1y8ugf">
            <h2 id="apply-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-992" data-mp="1kqaizrtp1oxi">
              Ready to join?
            </h2>

            <p className="mt-4 max-w-xl mx-auto text-base text-charcoal/70 leading-relaxed" data-id="element-993" data-mp="3mhnmqdjxdqrz">
              Create your account and choose your membership here, then complete
              your practitioner profile and verification in the Fem Entity app.
            </p>

            <a href="/practitioners/join" className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-purple-700 px-8 py-4 text-base font-semibold text-white transition-colors duration-200 ease-out hover:bg-purple-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-994" data-mp="1bwmqym6b5wur">
              Join Fem Entity
              <ArrowRightIcon aria-hidden="true" className="w-4 h-4" data-id="element-995" data-mp="16vp9ycx1b8uu" />
            </a>

            <p className="mt-5 text-sm text-charcoal/60" data-id="element-996" data-mp="1235v7cmm27og">
              Need to manage your plan?{' '}
              <a href="/practitioners/account/membership" className="font-semibold text-purple-700 underline underline-offset-4 decoration-purple-300 hover:text-purple-900 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600" data-id="element-997" data-mp="edbntal29bbl">
                Manage your Membership
              </a>
            </p>
          </div>
        </section>

        {/* Practitioner Coffee Chats */}
        <CoffeeChatInvite data-id="element-998" data-mp="3rfdznyfdiksp" />
      </main>

      <SiteFooter currentPath="/practitioners" data-id="element-999" data-mp="3rg70yjvkci3g" />
    </div>;
}